import React, {
    useState
} from 'react';

import { 
   IonPage,
   IonHeader,
   IonContent,
   IonToolbar,
   IonTitle,
   IonGrid,
   IonRow,
   IonCol,
   IonButtons,
   IonButton,
   IonBackButton,
   NavContext,
   IonCard,
    IonCardHeader,
    IonCardSubtitle,
    IonCardContent,
    IonCardTitle,
    useIonViewWillEnter
} from '@ionic/react';

import { Storage } from '@capacitor/storage';   
import NServer from "../components/NServer";
import { LANGUAGE, GetStr } from "../language/Language";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

import '../pages/Main.css'; 

interface PassCheckProp {
    onSubmit : any;
    onChange : any;
    onBiometric : any;
}

// check whether passcode is set
export const checkPasscode = async (r : any) : Promise<boolean> => {
    let v = new Vault();
    await v.read();

    const state = {
        id: v.account.id,
        pass: v.account.key
    };

    var server = new NServer();
    await server.getList("passcode_check", state);

    if (!server.success && server.message != "")
        showAlert(server.message);
    else
    {
        if (server.data.passcode != 1)
        {
            r.push("/lockset", "back", "pop");
            return false;
        }
    }
    // else
    return true;
}


// pass check control
const PassCheckCtrl : React.FC<PassCheckProp> = ({ onSubmit, onChange, onBiometric }) => {
    
    const [index, setIndex] = useState(0);
    const [lock, setLock] = useState("-- -- --");
    const [display, setDisplay] = useState("-- -- --");

    useIonViewWillEnter(() => {
        if (onBiometric != null)
            checkForBiometric();
    });

    const checkForBiometric = async () => {
        let v = new Vault();
        await v.read();

        if (v.account.biometric)
        {
            let id = v.account.id + 7445;
            let server = id + ".nwallet.me";
            v.biometricLogin(server, 
                (username : string, password : string)=> {
                    // success
                    onBiometric(username, password);
                },
                ()=> {
                    // faill
                }
            );
        }
    }

    const passkeyFill = () : boolean => {
        let pos = lock.search("-");
        return pos >= 0;
    };

    // display the number
    const setNum = (val : string) => {
        var i = index;
        var lk = lock;
        var dk = lock;
        var stars = "** ** **";

        if (index == 2)
            i = 3;
        if (index == 5)
            i = 6;
        
        if (index < 8) {
            lk = lock.substr(0, i) + val + lock.substr(i+1);
            setLock(lk);
            dk = stars.substr(0, i) + val + lock.substr(i+1);
            setDisplay(dk);
            setIndex(i+1);
        }
        
        if (index >= 7)
            setDisplay(stars);

        onChange(lk);
    };

    // clear one digit
    const setBack = () => {
        var i = index;
        var lk = lock;
        var dk = lock;
        var stars = "** ** **";

        if (index - 1 >= 0)
        {
            if (index == 3)
                i = 2;
            if (index == 6)
                i = 5;
                
            lk = lock.substr(0, i-1) + "-" + lock.substr(i);
            setLock(lk);
            dk = stars.substr(0, i-1) + "-" + lock.substr(i);
            setDisplay(dk);

            setIndex(i-1);
        }
        onChange(lk);
    };

    // clear whole thing
    const setClear = () => {
        setLock("-- -- --");
        setDisplay("-- -- --");
        setIndex(0);
        onChange("-- -- --");
    };

    return (
        <IonCard className="flat-card">
            <IonCardHeader>
                <IonCardSubtitle>{ GetStr(LANGUAGE.TXT_ENTER_PASSKEY) }</IonCardSubtitle>
                <IonCardTitle><h1><div className="ion-text-center">{display}</div></h1></IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("1") }} >
                                <h1>1</h1>
                            </IonButton>
                        </IonCol>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("2") }}>
                                <h1>2</h1>
                            </IonButton>
                        </IonCol>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("3") }}>
                                <h1>3</h1>
                            </IonButton>
                        </IonCol>
                    </IonRow> 
                    <IonRow>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("4") }}>
                                <h1>4</h1>
                            </IonButton>
                        </IonCol>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("5") }}>
                                <h1>5</h1>
                            </IonButton>
                        </IonCol>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("6") }}>
                                <h1>6</h1>
                            </IonButton>
                        </IonCol>
                    </IonRow> 
                    <IonRow>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("7") }}>
                                <h1>7</h1>
                            </IonButton>
                        </IonCol>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("8") }}>
                                <h1>8</h1>
                            </IonButton>
                        </IonCol>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("9") }}>
                                <h1>9</h1>
                            </IonButton>
                        </IonCol>
                    </IonRow> 
                    <IonRow>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={setClear} >
                                { GetStr(LANGUAGE.TXT_CLEAR) }
                            </IonButton>
                        </IonCol>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={() => { setNum("0") }}>
                                <h1>0</h1>
                            </IonButton>
                        </IonCol>
                        <IonCol>
                                <IonButton color="primary" expand="block" fill="clear" onClick={setBack} >
                                { GetStr(LANGUAGE.TXT_DEL) }
                            </IonButton>
                        </IonCol>
                    </IonRow> 
                    <IonRow className="ion-padding-top">
                        <IonCol>
                            <IonButton className="main-but" color="primary" expand="block" onClick={onSubmit} disabled={passkeyFill()}>
                                { GetStr(LANGUAGE.TXT_SUBMIT_PASSKEY) }
                            </IonButton>
                        </IonCol>
                    </IonRow> 
                </IonGrid>
            </IonCardContent>
        </IonCard>
    );
}

export default PassCheckCtrl;